import { render, staticRenderFns } from "./SearchStatsBody.container.vue?vue&type=template&id=01832a14&"
import script from "./SearchStatsBody.container.vue?vue&type=script&lang=ts&"
export * from "./SearchStatsBody.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports